@if (puffDataToUse() && puffDataToUse().acf) {
  <div [ngClass]="'puff-container-' + index()" class="vd-card vd-card-white puff-container">
    @if (hasImage()) {
      <div class="puff-image-container">
        <app-media-item
          [image]="puffDataToUse().acf.mainImage"
          [isNarrowColumnImage]="true"
          [isPriority]="index() < numberOfPriorityPuffs()"
          [routePath]="routePath()"
        ></app-media-item>
      </div>
    }
    @if (puffDataToUse().acf.isSponsored) {
      <div class="sponsored-label">Sponsrad</div>
    }

    <div [ngClass]="contentCssClass()" class="puff-text-container">
      <a
        [innerHTML]="puffDataToUse().title.rendered"
        [ngClass]="titleCssClass()"
        [routerLink]="routePath()"
        class="block text-left text-xl font-bold"
      ></a>
      <div class="vd-card-content text-grey-1">
        <div [innerHtml]="puffDataToUse().acf.puffDescription"></div>
        @if (puffDataToUse().acf.sponsoredDescription !== '') {
          <div
            [innerHtml]="puffDataToUse().acf.sponsoredDescription"
            class="caption"
          ></div>
        }
      </div>
    </div>
  </div>
}

